export const ObserverType = Object.freeze({
	read: 'read',
	none: 'none',
});
export const RequestMode = Object.freeze({
	history: 'history',
	unread: 'unread'
});
export const DateFormat = Object.freeze({
	groupTitle: 'groupTitle',
	readedTitle: 'readedTitle'
});